import { useTranslation } from 'next-i18next/pages';
import { searchProblemMessage } from 'utils/searchFormRules';

interface ISearchProblemProps {
  // A key of SEARCH_PROBLEM_MESSAGES (utils/searchFormRules.js), or null.
  problem: string | null;
  className?: string;
}

// WHIT-494: what the search form still needs, said under it when Search is
// pressed. Search used to do nothing at all, or only open a calendar, so
// nobody could tell why nothing happened. role="alert" reads it out.
const SearchProblem: React.FC<ISearchProblemProps> = ({
  problem,
  className,
}) => {
  const { t } = useTranslation();
  const message = searchProblemMessage(problem);
  if (!message) return null;
  return (
    <p
      role="alert"
      data-search-problem
      className={`text-sm font-medium text-tt-error-red ${className || ''}`}>
      {t(message)}
    </p>
  );
};

export default SearchProblem;
